//Vistas del main layout:
// import DefaultView from '../../../views/Dev';

import AuditView from '../../../views/AuditView';
import UsersManagement from '../../../views/UsersManagement';
import ProcessesRegistry from '../../../views/ProcessesRegistry';
import AlertsRegistry from '../../../views/AlertsRegistry';
import DownloadSourcesResume from '../../../views/DownloadSourcesResume';
import DownloadSourcesConfiguration from '../../../views/DownloadSourcesConfiguration';

let mainMenuRoutes = [
    // {
    //     path: "/dashboard",
    //     name: "Dashboard",
    //     subname: "Dashboard",
    //     icon: "nc-icon nc-chart-pie-36",
    //     component: DefaultView,
    //     layout: "/admin"
    // },
    {
        id: "extraccion",
        name: "Extracción",
        icon: "nc-icon nc-tap-01",
        dropdown: true,
        adminRequired: false,
        children: [
            {
                path: "/sources",
                name: "Fuentes",
                subname: "Fuentes de descarga",
                icon: "nc-icon nc-book-bookmark",
                component: DownloadSourcesResume,
                layout: "/admin",
                adminRequired: false
            },
            {
                path: "/reportes",
                name: "Reportes",
                subname: "Reportes",
                icon: "nc-icon nc-single-copy-04",
                component: ProcessesRegistry,
                layout: "/admin",
                adminRequired: false
            },
            {
                path: "/alertas",
                name: "Alertas",
                subname: "Historial de Alertas",
                icon: "nc-icon nc-bell-55",
                component: AlertsRegistry,
                layout: "/admin",
                adminRequired: false
            }
        ]
    },
    {
        path: "/auditoria",
        name: "Auditoría",
        subname: "Auditoría",
        icon: "nc-icon nc-zoom-split",
        component: AuditView,
        layout: "/admin",
        adminRequired: true
    },
    {
        path: "/seguridad",
        name: "Seguridad",
        subname: "Seguridad",
        icon: "nc-icon nc-touch-id",
        component: UsersManagement,
        layout: "/admin",
        adminRequired: false
    },
    {
        bottom: true,
        path: "/configuracion",
        name: "Configuración",
        subname: "Configuración",
        icon: "nc-icon nc-settings-gear-65",
        component: DownloadSourcesConfiguration,
        layout: "/admin",
        adminRequired: true
    }
];

// Helper function to flatten routes for Router
export const getFlattenedRoutes = () => {
    const flatRoutes = [];
    
    mainMenuRoutes.forEach(route => {
        if (route.dropdown && route.children) {
            // Add child routes
            route.children.forEach(child => {
                flatRoutes.push(child);
            });
        } else {
            // Add regular routes
            flatRoutes.push(route);
        }
    });
    
    return flatRoutes;
};

export default mainMenuRoutes;
